import { Quote } from '@core/models/swagger';
import { createAction, props } from '@ngrx/store';

export enum QuoteActions {
  ResetQuote = '[Flow Data Quote] Reset quote',
  UpdateQuote = '[Flow Data Quote] Update quote',
}

export const ResetQuote = createAction(QuoteActions.ResetQuote);

export const UpdateQuote = createAction(QuoteActions.UpdateQuote, props<{ data: Quote }>());

